<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-page-header @back="goBack" content="查看商品"></el-page-header>
		<el-form label-position="right" :model="item" label-width="auto">
			<el-form-item label="商品名称" prop="name">
				<el-input v-model="item.name" placeholder="请输入商品名称"></el-input>
			</el-form-item>
			<el-form-item label="副标题">
				<el-input v-model="item.caption" placeholder="请输入副标题"></el-input>
			</el-form-item>
			<el-form-item label="是否上架">
				<el-switch v-model="item.is_marketable" active-color="#13ce66" inactive-color="#cccccc">
				</el-switch>
			</el-form-item>
			<el-form-item label="所属品牌">
				<el-select v-model="item.brand_id" filterable placeholder="请选择">
					<el-option v-for="item in brandList" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="平台分类" prop="product_category_id">
				<el-cascader v-model="item.product_category_id" placeholder="请选择" :options="adminCategoryList"
							 :props="filterProps" clearable></el-cascader>
			</el-form-item>
			<div>
				<div class="goods-spec">
					<el-link type="primary" @click="addPrivateSpec" class="goods-spec-add" style="">添加规格</el-link>
				</div>
				<div class="goods-container" v-for="(attr, index) in privateGoodsItem" :key="index">
					<div class="goods-content">
						<div class="goods-content-box">
							<div class="goods-content-left">
								<el-form-item label="规格名">
									<el-input v-model="attr.privateSpecName" placeholder="请输入规格名"></el-input>
								</el-form-item>
								<el-form-item label="规格值">
									<el-tag v-for="tag in attr.dynamicTags" :key="tag" closable
										:disable-transitions="false" @close="handleClose(tag, attr)">
										{{tag}}
									</el-tag>
									<!--  inputVisible控制是否显示  inputValue值 -->
									<!-- @keyup.enter.native点击回车的时候 判断是否有值决定是否隐藏 -->
									<!-- input失焦blur的时候 判断是否有值决定是否隐藏-->
									<el-input class="input-new-tag" v-show="attr.inputVisible" v-model="attr.inputValue"
										:ref="`saveTagInput${index}`" size="small"
										@keyup.enter.native="handleInputConfirm(attr.inputValue, attr)"
										@blur="handleInputConfirm(attr.inputValue, attr)"></el-input>
									<el-button v-show="!attr.inputVisible" class="button-new-tag" size="small"
										@click="showInput(attr, index)">+ 添加</el-button>
								</el-form-item>
							</div>
							<div class="goods-content-right">
								<el-link type="danger" @click="delPrivateSpec(index)">删除规格</el-link>
							</div>
						</div>
					</div>
				</div>
				<!-- <p style="margin:22px 0 10px 0">价格</p> -->
				<el-table style="margin-bottom: 22px; margin-top:0;" ref="multipleTable"
					:data="tableColumnList.tableBodyList" border tooltip-effect="dark">
					<el-table-column :label="item.propName" :property="item.prop"
						v-for="item in tableColumnList.tableHeaderList" :key="item.prop" align="center">
						<template slot-scope="scope">
							<span>{{ scope.row[scope.column.property] }}</span>
						</template>
					</el-table-column>
					<el-table-column label="销售价（元）">
						<template slot-scope="scope">
							<el-input v-model="scope.row.price"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="成本价（元）">
						<template slot-scope="scope">
							<el-input v-model="scope.row.cost"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="市场价（元）">
						<template slot-scope="scope">
							<el-input v-model="scope.row.market_price"></el-input>
						</template>
					</el-table-column>
				</el-table>
			</div>

			<el-form-item label="商品主图" prop="product_pic_main">
				<el-upload
						class="single-image"
						list-type="single-image"
						:on-success="(value) => uploadSuccess('product_pic_main', 'single', value)"
						:show-file-list="false"
						:action="app_url + '/store/uploader/upload'">
					<div class="icon" v-if="!item.product_pic_main">
						<i class="el-icon-plus"></i>
						<span>图片规格：500px x 500px</span>
					</div>

					<img :src="item.product_pic_main" v-else>
				</el-upload>
			</el-form-item>
			<el-form-item label="细节图" prop="product_images">
				<div>
					<ul class="el-upload-list el-upload-list--picture-card">
						<li :tabindex="index" class="el-upload-list__item is-success" v-for="(src, index) in item.product_images" :key="index">
							<img :src="src" alt="" class="el-upload-list__item-thumbnail">
							<label class="el-upload-list__item-status-label">
								<i class="el-icon-upload-success el-icon-check"></i>
							</label>
							<i class="el-icon-close"></i><i class="el-icon-close-tip">按 delete 键可删除</i>
							<span class="el-upload-list__item-actions">
								<span class="el-upload-list__item-preview">
									<i class="el-icon-zoom-in"></i></span>
								<span class="el-upload-list__item-delete" @click="delectImage('product_images', index)">
									<i class="el-icon-delete"></i>
								</span>
							</span>
						</li>
					</ul>
					<el-upload
							class="single-image"
							style="display: inline"
							:multiple="true"
							:limit="10 - item.product_images.length"
							:action="app_url + '/store/uploader/upload'"
							list-type="picture-card"
							:show-file-list="false"
							:on-success="(value) => uploadSuccess('product_images', 'multi', value)">
						<div class="icon">
							<i class="el-icon-plus"></i>
							<span>图片规格：1125px x 817px</span>
						</div>
					</el-upload>
				</div>
			</el-form-item>
			<el-form-item label="商品详情" id="quill-upload">
				<el-upload :action="app_url + '/store/uploader/upload'" multiple :show-file-list="false" :on-success="editorSuccess"
					:on-error="uploadError" style="display: none;">
				</el-upload>
				<quill-editor ref="quill" v-model="item.introduction" :options="editorOption" />
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'
	import {
		quillEditor
	} from 'vue-quill-editor'
	export default {
		data() {
			return {
				item: {},
				isLoad: false,
				id: this.$route.query.id,
				dialogVisible: false,
				productImages: [],
				product_pic_main: [],
				op: this.$route.query.op || 0, // 0-查看，1-新增，2-修改
				isView: false,
				supplierCategoryList: [], // 供应商商品分类列表
				brandList: [], // 品牌列表
				adminCategoryList: [], // 平台商品分类列表
				industryTemplateList: [], // 行业模板
				parameter: [],

				tableColumnList: {
					tableHeaderList: [],
					tableBodyList: []
				},
				privateGoodsItem: [],
				// 方法的变量
				goods_option: [],

				editorOption: {
					modules: {
						toolbar: {
							container: [
								['bold', 'italic', 'underline', 'strike'],
								['blockquote', 'code-block'],
								[{
									'header': 1
								}, {
									'header': 2
								}],
								[{
									'list': 'ordered'
								}, {
									'list': 'bullet'
								}],
								[{
									'script': 'sub'
								}, {
									'script': 'super'
								}],
								[{
									'indent': '-1'
								}, {
									'indent': '+1'
								}],
								[{
									'direction': 'rtl'
								}],
								[{
									'size': ['small', false, 'large', 'huge']
								}],
								[{
									'header': [1, 2, 3, 4, 5, 6, false]
								}],
								[{
									'color': []
								}, {
									'background': []
								}],
								[{
									'font': []
								}],
								[{
									'align': []
								}],
								['clean'],
								['image', 'video']
							],
							handlers: {
								image: function(value) {
									if (value)
										document.querySelector('#quill-upload input').click()
									else
										this.quill.format('image', false);
								}
							}
						}
					},
				},
			}
		},
		created() {
			this.loadData()
		},
		computed: {
			// 规格名变化执行这个函数
			calculateAttribute() {
				let obj = {}
				this.privateGoodsItem.forEach((item) => {
					//privateSpecName 规格名
					if (item.privateSpecName) {
						obj[item.privateSpecName] = item.dynamicTags
					}
				})
				return obj
			}
		},
		watch: {
			// 规格名的子元素规格值变化执行这个函数
			calculateAttribute(newVal) {
				let cloneNewVal = JSON.parse(JSON.stringify(newVal))
				let attrName = []
				let attrValue = []
				for (let key in cloneNewVal) {
					attrName.push(key)
					attrValue.push(cloneNewVal[key])
				}
				let finalArr = this.cartesianProductOf(...attrValue)
				console.log(finalArr);
				let tableObj = {
					tableBodyList: [],
					tableHeaderList: []
				}
				tableObj.tableBodyList = finalArr.map((item) => {
					let obj = {
						id: this.goods_option[item.join('|')] ? this.goods_option[item.join('|')].id : '',
						price: this.goods_option[item.join('|')] ? this.goods_option[item.join('|')].price :
							'',
						market_price: this.goods_option[item.join('|')] ? this.goods_option[item.join('|')]
							.market_price : '',
						cost: this.goods_option[item.join('|')] ? this.goods_option[item.join('|')].cost : ''
					}
					for (let i = 0; i < item.length; i++) {
						obj[attrName[i]] = item[i]
					}
					return obj
				})
				this.tableColumnList.tableBodyList = tableObj.tableBodyList
				let skuTableArr = Object.keys(newVal)
				tableObj.tableHeaderList = skuTableArr.map((item) => {
					return {
						prop: item,
						propName: item
					}
				})
				this.tableColumnList.tableHeaderList = tableObj.tableHeaderList
			}
		},
		methods: {
			loadData: async function() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad

				// 中控：商品分类树
				await this.axios.get('/store/data/getCategoryTreeAdmin', {}).then(res => {
					this.adminCategoryList = res.data.list
				})

				// 品牌列表
				await this.axios.get('/store/data/listBrandForSelect', {}).then(res => {
					this.brandList = res.data
				})

				// 获取商品信息
				if (this.id) {
					await this.axios.post('/store/product/supplierdetail', {
						id: this.id
					}).then(res => {
						if(res.data.detail.specifications){
							res.data.detail.specifications.forEach(key => {
								key.specValue = key.specValue.split(',')
								key.inputVisible = false
								key.inputValue = ''
							})

							res.data.detail.specifications.forEach((key, index) => {
								this.$set(key, 'dynamicTags', key.specValue)
								this.$set(key, 'privateSpecName', key.specName)
								this.tableColumnList.tableHeaderList[index] = {}
								this.$set(this.tableColumnList.tableHeaderList[index], 'propName', key.specName)
								this.$set(this.tableColumnList.tableHeaderList[index], 'prop', key.specName)
							})
							this.privateGoodsItem = res.data.detail.specifications
						}

						res.data.detail.sku.forEach((key, index) => {
							let skuName1 = key.sku_name.split(',')
							let skuNameArr = ''
							for (let i = 0; i < skuName1.length; i++) {
								skuNameArr += skuName1[i] + '|'
							}
							skuNameArr = skuNameArr.substr(0, skuNameArr.length - 1)
							let obj = {
								id: key.id,
								price: key.price,
								market_price: key.market_price,
								cost: key.cost
							}
							this.goods_option[skuNameArr] = obj
						})

						this.item = res.data.detail
						this.item.is_marketable = this.item.is_marketable.toString()
						// this.item.store_category_id = this.item.store_category_id.toString()
						this.$forceUpdate()
					})
				}
				this.isLoad = !this.isLoad
			},
			// 后退一步
			goBack() {
				this.$router.back(-1)
			},
			addPrivateSpec() {
				this.privateGoodsItem.push({
					privateSpecName: '',
					dynamicTags: [],
					inputVisible: false,
					inputValue: ''
				})
			},
			delPrivateSpec(index) {
				this.privateGoodsItem.splice(index, 1)
			},
			handleInputConfirm(val, attr) {
				if (val)
					attr.dynamicTags.push(val)
				attr.inputVisible = false
				attr.inputValue = ''
			},
			handleClose(tag, item) {
				item.dynamicTags.splice(item.dynamicTags.indexOf(tag), 1)
			},
			showInput(attr, index) {
				attr.inputVisible = true
				this.$nextTick(() => {
					this.$refs[`saveTagInput${index}`][0].$refs.input.focus()
				})
			},
			cartesianProductOf(...args) {
				return args.reduce((total, current) => {
					let ret = []
					total.forEach((a) => {
						current.forEach((b) => {
							ret.push(a.concat([b]))
						})
					})
					return ret
				}, [
					[]
				])
			},

			uploadError() {
				this.$message.error({
					message: '上传失败'
				});
			},
			beforeUpload(file) {
				var testmsg = file.type;
				const extension = (testmsg === "image/jpeg" || testmsg === "image/png");
				if (!extension) {
					this.$message({
						message: "上传文件只能是jpg或png格式!",
						type: "warning",
					});
				}
				return extension;
			},
			uploadSuccess(key, model, res, file) {
				if (model == 'single') {
					this.item[key] = res.data.fileInfo.external_url
				} else {
					this.item[key].push(res.data.fileInfo.external_url)
				}

			},
			delectImage: function (key, index) {
				this.item[key].splice(index, 1)
			},
			// 富文本图片上传
			editorSuccess(res) {
				let quill = this.$refs.quill.quill
				let length = quill.getSelection().index
				// 上传图片的路径
				quill.insertEmbed(length, 'image', res.data.fileInfo.external_url)
				quill.setSelection(length + 1)
				this.$message.success({
					message: '上传成功'
				});
			}
		},
		components: {
			quillEditor
		}
	}
</script>
<style scoped>
	.goods-spec {
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.goods-spec .goods-spec-add {
		margin-left: 30px;
		margin-bottom: 14px;
	}

	.goods-container .button-new-tag {
		height: 32px;
		line-height: 30px;
		padding-top: 0;
		padding-bottom: 0;
	}

	.goods-container .input-new-tag {
		width: 90px;
		margin-right: 10px;
		vertical-align: bottom;
	}

	.goods-container .el-tag {
		margin-right: 10px;
	}

	.goods-container .goods-content {
		margin-bottom: 10px;
		padding: 14px;
		border: 1px solid #ebeef5;
		border-radius: 4px;
		background-color: #fcfcfc;
	}

	.goods-content .goods-content-box {
		display: flex;
		align-items: center;
	}

	.goods-content-box .goods-content-left {
		flex: 1;
	}
</style>
